
// Type-safe environment variable definitions
interface CustomImportMetaEnv {
  readonly VITE_GOOGLE_CLIENT_ID: string;
  readonly VITE_API_BASE_URL: string;
  readonly VITE_APP_DOMAIN: string;
  readonly MODE: string;
  readonly DEV: boolean;
  readonly PROD: boolean;
}

// Required environment variables - backend dev will configure these
const requiredEnvVars = [
  'VITE_GOOGLE_CLIENT_ID',
  'VITE_API_BASE_URL',
  'VITE_APP_DOMAIN'
] as const;

const validateEnv = (): CustomImportMetaEnv => {
  const env = {
    VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '1046591759929-fjj9pt1p6hk691fjs5je6d135ktqdlqh.apps.googleusercontent.com',
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.placeholder.com',
    VITE_APP_DOMAIN: import.meta.env.VITE_APP_DOMAIN || 'localhost:8080',
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
    PROD: import.meta.env.PROD,
  };

  return env;
};

export const env = validateEnv();

export const config = {
  google: {
    clientId: env.VITE_GOOGLE_CLIENT_ID,
  },
  api: {
    baseUrl: env.VITE_API_BASE_URL,
  },
  app: {
    domain: env.VITE_APP_DOMAIN,
    isDev: env.DEV,
    isProd: env.PROD,
  },
  security: {
    // Security configuration
    maxTimestampAge: 5 * 60 * 1000, // 5 minutes for CSRF protection
    jwtValidationEnabled: true,
    requestValidationEnabled: true,
  },
} as const;
